import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";
import api from "@/lib/api";

const InsightDetail = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    setStatus("loading");
    api
      .get(`/posts/${slug}`)
      .then((res) => {
        setPost(res.data);
        setStatus("ok");
      })
      .catch(() => setStatus("notfound"));
  }, [slug]);

  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <div className="h-10 w-10 rounded-full border-2 border-navy/20 border-t-navy animate-spin" />
      </div>
    );
  }

  if (status === "notfound") {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-cream text-center px-6">
        <h1 className="font-serif text-4xl text-navy">Article not found</h1>
        <Button asChild className="mt-6 rounded-full bg-navy text-cream">
          <Link to="/insights">Back to Insights</Link>
        </Button>
      </div>
    );
  }

  return (
    <div data-testid="insight-detail-page">
      <section className="relative pt-40 pb-16 bg-navy text-cream grain">
        <div className="relative mx-auto max-w-3xl px-6">
          <Link
            to="/insights"
            data-testid="back-to-insights"
            className="inline-flex items-center gap-2 text-cream/70 hover:text-gold transition-colors duration-300 text-sm"
          >
            <ArrowLeft size={16} /> All Insights
          </Link>
          <p className="overline mt-8 mb-4">{post.category}</p>
          <h1 className="font-serif font-light tracking-tight text-3xl md:text-5xl leading-tight text-cream">
            {post.title}
          </h1>
          <p className="mt-6 text-cream/70">By {post.author}</p>
        </div>
      </section>

      <div className="mx-auto max-w-3xl px-6 -mt-8">
        <Reveal>
          <div className="overflow-hidden rounded-3xl soft-shadow">
            <img src={post.cover_image} alt={post.title} className="h-[420px] w-full object-cover" />
          </div>
        </Reveal>
      </div>

      <article className="mx-auto max-w-3xl px-6 py-16">
        <p className="font-serif text-2xl text-navy leading-relaxed mb-8 italic">{post.excerpt}</p>
        {post.content.split("\n").filter(Boolean).map((para, i) => (
          <p key={i} className="text-lg text-slate-700 leading-relaxed mb-6">
            {para}
          </p>
        ))}
      </article>

      <section className="mx-auto max-w-3xl px-6 pb-28">
        <div className="rounded-3xl bg-teal px-8 py-12 text-cream text-center">
          <h2 className="font-serif text-2xl md:text-3xl">Discuss this with Epic Consultancy</h2>
          <Button asChild className="mt-6 rounded-full bg-gold text-navy hover:bg-gold-bright px-8 h-12">
            <Link to="/contact" data-testid="insight-cta">Book a Consultation</Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default InsightDetail;
